import { Component } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { WsShopallService } from 'src/app/ws/wsShopAll/ws-shopall.service';
import { lastValueFrom } from 'rxjs';
import { MGetAllShopAllModuleDataResponse, MGetBrandByInitialsRequest, MGetBrandResponse, MGetPriceListRequest, MGetProductRequest, MGetProductResponse } from '../product-type-beauty/product-type-beauty.module';
import { MCommonListModalRequest, SharedPrefrences } from 'src/app/utils/utils.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MAddUpdateCartModule, MAddUpdateCartModuleResponse } from '../product-detail-updated/product-detail-updated.module';
import { CommonBehaviorChangeService } from 'src/app/utils/common-behaviour-service';
import { LoginPopupComponent } from 'src/app/components/login-popup/login-popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WsUserProfileService } from 'src/app/ws/wsUserProfile/ws-user-profile.service';
import { WsBlogService } from 'src/app/ws/wsBlog/ws-blog.service';
import { MCategoryResponseModal } from '../blog/blog.module';
@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})
export class ProductComponent {

  isHeartChecked: boolean = false;
  categoryDetails: any;
  priceLists: any = [];
  selectedPrice: any = [];
  pricerange: any;
  tags: any = '';
  leafLevelCategoryId: any;
  selectedLeafLevelCategory: any = [];
  leafLevelCategoryList: any = [];
  selectIndex!: number;
  appClass=true;
  categoryCode: any;
  subCategoryCode: any;
  leafLevelCategoryName: any;
  isLoading!: boolean;
  toggleHeart() {
    this.isHeartChecked = !this.isHeartChecked;
  }

  categoriesSlider: OwlOptions = {
    loop: true,
    margin: 0,
    autoplay: true,
    autoplayTimeout: 5000,
    smartSpeed: 1000,
    dots: false,
    center: false,
    nav: false,

    responsive: {
      0: {
        items:3.5,
        margin: 20,
      },
      576: {
        items: 3.4,
        margin: 15,
      },
      768:{
        items: 4.4,
        margin: 20,
      },
      1024: {
        items: 6,
        margin: 30,
      },
      1250: {
        items: 6,
        margin: 30,
      },
      1600: {
        items: 6,
        margin: 30,
      }
    }
  }

  categoryId!: any;
  mGetAllShopAllModuleDataResponse: any = new MGetAllShopAllModuleDataResponse();
  mCommonListModalRequest: MCommonListModalRequest = new MCommonListModalRequest();
  mGetBrandResponse: any = new MGetBrandResponse()
  subCategoryId: any = '';
  mGetProductRequest: any = new MGetProductRequest()
  mGetPriceListRequest: MGetPriceListRequest = new MGetPriceListRequest()
  mGetProductResponse: any = new MGetProductResponse();
  mGetBrandByInitialsRequest: MGetBrandByInitialsRequest = new MGetBrandByInitialsRequest()
  skinTypeId: any;
  skinConcernId: any;
  skinConcernArray: any = [];
  skinTypeArray: any = [];
  sortBy: boolean = false;
  brandId: any;
  relevence: any = null;
  priceHighToLow: any = null;
  brandCount: number = 0;
  productCount: any = 0;
  mAddUpdateCartModule: MAddUpdateCartModule = new MAddUpdateCartModule();
  mAddUpdateCartModuleResponse: any = new MAddUpdateCartModuleResponse()
  gender: any = null;
  sortByOne: any;
  state: any;
  type: any;
  mWishlistData: any = []
  selectedBrandList: any = []
  selectedSubCategory: any = [];
  selectedCategory: any = [];
  mCategoryResponseModal: MCategoryResponseModal = new MCategoryResponseModal()
  subCategoryList: any = [];
  subCategoryCount: any;
  genderList: any = [];
  selectedSortBy: any = '';
  totalPages: number = 0;
  pageList: any = [];
  selectedPage: any = 1;
  previousPage:any = 1;
  discountmode: any;
  discountValueType: any;
  discountValue: any;
  discountType: any;
  isdiscounted: boolean = false;
  selectedFilter!: number;

  constructor(private wsblogservice: WsBlogService, 
    private wsUserProfileService: WsUserProfileService, 
    private activatedRoute: ActivatedRoute, private modalService: NgbModal, 
    private wsShopAllService: WsShopallService, private router: Router, 
    private _commonBehaviorChangeService: CommonBehaviorChangeService) {

    this.activatedRoute.queryParams.subscribe(async (params:any) => {
      const filters = {
        c: params.c || "",
        sub: params.sub || "",
        sc: params.sc || "",
        st: params.st || "",
        b: params.b || "",
        r: params.r || "",
        phl: params.phl || "",
        pc: params.pc || "",
        g: params.g || "",
        l3: params.l3 || ""
      };

      if(filters['c']){
        this.categoryId = filters['c']
        this.selectedCategory = await this.filterCommon(this.categoryId)
      }
      if(filters['sub']){
        this.subCategoryId = filters['sub']
        this.selectedSubCategory = await this.filterCommon(this.subCategoryId)
        this.wsShopAllService.getLeafCategoryList(this.subCategoryId).subscribe((res:any) =>{
          this.leafLevelCategoryList = res['data']
        })
      }else{
        this.wsShopAllService.getLeafCategoryList(this.subCategoryId).subscribe((res:any) =>{
          this.leafLevelCategoryList = res['data']
        })
      }
      if(filters['l3']){
        this.leafLevelCategoryId = filters['l3']
        this.selectedLeafLevelCategory = await this.filterCommon(this.leafLevelCategoryId)
      }
      if(filters['sc']){
        this.skinConcernId = filters['sc']
        this.skinConcernArray = await this.filterCommon(this.skinConcernId)
      }
      if(filters['st']){
        this.skinTypeId = filters['st']
        this.skinTypeArray = await this.filterCommon(this.skinTypeId)
      }
      if(filters['b']){
        this.brandId = filters['b']
        this.selectedBrandList = await this.filterCommon(this.brandId)
        this.selectIndex = this.selectedBrandList.length;
      }
      else{
        this.selectIndex = 0;
      }
      if(filters['r']){
        if(filters['r'] == 'true' || filters['r'] == true){
          this.relevence = true;
          this.selectedSortBy = '(Popularity)';
        }else{
          this.relevence = false;
        }
      }
      if(filters['phl']){
        if(filters['phl'] == 'true' || filters['phl'] == true){
          this.priceHighToLow = true;
          this.selectedSortBy = '(Price High to low)';
        }else{
          this.priceHighToLow = false;
          this.selectedSortBy = '(Price Low to High)';
        }
      }
      if(filters['pc']){
        this.pricerange = filters['pc']
        this.selectedPrice = await this.filterCommon(this.pricerange)
      }
      if(filters['g']){
        this.gender = filters['g']
      }

      this.selectedFilter = 
      (this.categoryId && this.categoryId !== '' ? 1 : 0) +
      (this.subCategoryId && this.subCategoryId !== '' ? 1 : 0) +
      (this.leafLevelCategoryId && this.leafLevelCategoryId !== '' ? 1 : 0) +
      (this.skinConcernId && this.skinConcernId !== '' ? 1 : 0) +
      (this.skinTypeId && this.skinTypeId !== '' ? 1 : 0) +
      (this.brandId && this.brandId !== '' ? 1 : 0) +
      (this.selectedSortBy && this.selectedSortBy != '' ? 1 : 0) +
      (this.pricerange!= null? 1: 0) +
      (this.gender != null ? 1 : 0);

    });
    this.activatedRoute.params.subscribe((data:any) =>{
      if(data['discountmode']){
        this.isdiscounted = true;
        this.discountmode = data['discountmode']
      }
      if(data['discountValueType']){
        this.isdiscounted = true;
        this.discountValueType = data['discountValueType']
      }
      if(data['discountValue']){
        this.isdiscounted = true;
        this.discountValue = data['discountValue']
      }
      if(data['discountType']){
        this.isdiscounted = true;
        this.discountType = data['discountType']
      }
      if(data['categoryCode']){
        this.isdiscounted = true;
        this.categoryCode = data['categoryCode']
      }
      if(data['subCategoryCode']){
        this.isdiscounted = true;
        this.subCategoryCode = data['subCategoryCode']
      }
      if(data['leafLevelCategoryName']){
        this.isdiscounted = true;
        this.leafLevelCategoryName = data['leafLevelCategoryName']
      }
      if(data['tags']){
        this.tags = data['tags']
      }
    })
    this._commonBehaviorChangeService.currentrCartList.subscribe((cartList: any) => {
      this.mAddUpdateCartModuleResponse.data = cartList.data;
      if (this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0) {
        this.mGetProductResponse.data && this.mGetProductResponse.data.length > 0 && this.mGetProductResponse.data.forEach((product: any) => {
          const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
          if (cartPresent.length > 0) {
            product.cartQty = cartPresent[0].qty;
          } else {
            product.cartQty = null;
          }
        })
      }
      else{
        this.mGetProductResponse.data && this.mGetProductResponse.data.length > 0 && this.mGetProductResponse.data.forEach((product: any) => {
          const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
          if (cartPresent.length > 0) {
            product.cartQty = cartPresent[0].qty;
          } else {
            product.cartQty = null;
          }
        })
      }
    })

    this._commonBehaviorChangeService.currentWishList.subscribe((wishList: any) => {
      this.mWishlistData = wishList;
    })

  }

  updateURLWithNewParamsWithoutReloading(clear?:any) {
    var queryParams:any = {
        c: null,
        sub: null,
        sc: null,
        st: null,
        b: null,
        r: null,
        phl: null,
        pc: null,
        g: null,
        l3: null
    }
    if (this.categoryId && this.categoryId != '') {
      queryParams['c'] = this.categoryId || ''
    }
    if (this.subCategoryId && this.subCategoryId != '') {
      queryParams['sub'] = this.subCategoryId
    }
    if (this.leafLevelCategoryId && this.leafLevelCategoryId != '') {
      queryParams['l3'] = this.leafLevelCategoryId
    }
    if (this.skinConcernId && this.skinConcernId != '') {
      queryParams['sc'] = this.skinConcernId
    }
    if (this.skinTypeId && this.skinTypeId != '') {
      queryParams['st'] = this.skinTypeId
    }
    if (this.brandId && this.brandId != '') {
      queryParams['b'] = this.brandId
    }
    if (this.relevence && this.relevence != null) {
      queryParams['r'] = this.relevence
    }
    if (this.priceHighToLow != null) {
      queryParams['phl'] = this.priceHighToLow
    }
    if (this.pricerange != null) {
      queryParams['pc'] = this.pricerange
    }
    if (this.gender != null) {
      queryParams['g'] = this.gender;
    }

    if(clear){
      queryParams['c'] = '1';
    }

    this.router.navigate([decodeURI(this.router.url.split("?")[0])], { 
      queryParams: queryParams,
      queryParamsHandling: 'merge'
  })
  
  this.selectedFilter = 
      (this.categoryId && this.categoryId !== '' ? 1 : 0) +
      (this.subCategoryId && this.subCategoryId !== '' ? 1 : 0) +
      (this.leafLevelCategoryId && this.leafLevelCategoryId !== '' ? 1 : 0) +
      (this.skinConcernId && this.skinConcernId !== '' ? 1 : 0) +
      (this.skinTypeId && this.skinTypeId !== '' ? 1 : 0) +
      (this.brandId && this.brandId !== '' ? 1 : 0) +
      (this.selectedSortBy && this.selectedSortBy != '' ? 1 : 0) +
      (this.pricerange!= null? 1: 0) +
      (this.gender != null ? 1 : 0);
}

  ngOnInit() {
    this.isLoading = true;
    if (SharedPrefrences.getUserId() != null && SharedPrefrences.getUserId() != '') {
      this.getAllCartProducts();
    }
    if(this.router.url.split('/')[3] && this.router.url.split('/')[2] != 'favourites'){
      if(parseInt(this.router.url.split('/')[3]))
        this.gender = parseInt(this.router.url.split('/')[3])
    }
    this.getAllBrand()
    this.getGender();
    this.getCategoryList();
    this.mGetBrandResponse.data = [];
    this.mGetProductResponse.data = [];
  
    window.scrollTo(0, 0);
  }

   /**
  * to get category list
  */
   async getCategoryList() {
    const categoryListData = this.wsblogservice.getCategoryByType(1);
    await lastValueFrom(categoryListData).then(response => {
      if (response && response.statusCode == 200) {
        this.mCategoryResponseModal.data = response.data;
        this.mCategoryResponseModal.data = this.mCategoryResponseModal.data.filter((item: any) => {
          if (item.is_active !== false) {
            return true;
          }
          return false;
      });
      if(this.categoryCode){
        this.categoryId = this.mCategoryResponseModal.data.find((cCode:any) => cCode.category_code == this.categoryCode)?.id;
        this.getAllModuleDataOfShopAll();
      }
      else{
        this.getAllModuleDataOfShopAll();
      }
      } else {
      }
    })
  }

  /**
 * Date:- 21-06-2023
 * Method :- This method is used to Get Order Detail List
 * @param userId :-  This param is used for request to Get Order Detail List
 */
  async getWishList() {
    const wishList = this.wsUserProfileService.getWishList("" + SharedPrefrences.getUserId())
    await lastValueFrom(wishList).then(async response => {
      if (response && response.statusCode == 200) {
        this.mWishlistData = response.data
      }
    })
  }

  /**
   * Date: 10-06-23
   * Method: This method is used to get subcategory , skintype and skin concern of selected category
   */
  async getAllModuleDataOfShopAll() {
    if(!this.isdiscounted && this.router.url.split('/')[2] != 'favourites'){
      if(this.categoryId){
    const getAllModuleDataOfShopAll = this.wsShopAllService.getAllModuleDataOfShopAll(""+this.categoryId)
    await lastValueFrom(getAllModuleDataOfShopAll).then(async response => {
      if (response && response.statusCode == 200) {
        this.mGetAllShopAllModuleDataResponse.data = response.data;
        this.mGetAllShopAllModuleDataResponse.data.subCategoryList = this.mGetAllShopAllModuleDataResponse.data.subCategoryList.filter((item: any)=>{
          if (item.is_active !== false){
            return true;
          }
          return false;
        })

        if(this.subCategoryCode){
          this.subCategoryId = this.mGetAllShopAllModuleDataResponse.data.subCategoryList.find((csubCode:any) => csubCode.sub_category_code == this.subCategoryCode)?.id;
          
          if(this.leafLevelCategoryName){
            this.wsShopAllService.getLeafCategoryList(this.subCategoryId).subscribe((res:any) =>{
              this.leafLevelCategoryList = res['data'];
            })
            this.leafLevelCategoryId = this.leafLevelCategoryList.find((lcat:any) => lcat.title == this.leafLevelCategoryName)?.id;
          }
        }
        
        this.categoryDetails = this.mGetAllShopAllModuleDataResponse.data.categoryDetails[0]
        if (this.mGetAllShopAllModuleDataResponse && this.mGetAllShopAllModuleDataResponse.data) {
            this.getAllProductByParameters();
            this.getPriceLists()
        }
      } else {
      }
    })
  }else{
    const getAllModuleDataOfShopAll = this.wsShopAllService.getAllModuleDataOfShopAllWithoutCategory()
    await lastValueFrom(getAllModuleDataOfShopAll).then(async response => {
      if (response && response.statusCode == 200) {
        this.mGetAllShopAllModuleDataResponse.data = response.data;
        this.categoryDetails = this.mGetAllShopAllModuleDataResponse.data.categoryDetails[0]
        if (this.mGetAllShopAllModuleDataResponse && this.mGetAllShopAllModuleDataResponse.data) {
            this.getAllProductByParameters();
            this.getPriceLists()
        }
      } else {
      }
    })
  }
    
  }else{
    if(this.categoryId){
      const getAllModuleDataOfShopAll = this.wsShopAllService.getAllModuleDataOfShopAll(""+this.categoryId)
      await lastValueFrom(getAllModuleDataOfShopAll).then(async response => {
        if (response && response.statusCode == 200) {
          this.mGetAllShopAllModuleDataResponse.data = response.data;
          this.mGetAllShopAllModuleDataResponse.data.subCategoryList = this.mGetAllShopAllModuleDataResponse.data.subCategoryList.filter((item: any)=>{
            if (item.is_active !== false){
              return true;
            }
            return false;
          })
  
          if(this.subCategoryCode){
            this.subCategoryId = this.mGetAllShopAllModuleDataResponse.data.subCategoryList.find((csubCode:any) => csubCode.sub_category_code == this.subCategoryCode)?.id;

            if(this.leafLevelCategoryName){
              this.wsShopAllService.getLeafCategoryList(this.subCategoryId).subscribe((res:any) =>{
                this.leafLevelCategoryList = res['data'];
              })
              this.leafLevelCategoryId = this.leafLevelCategoryList.find((lcat:any) => lcat.title == this.leafLevelCategoryName)?.id;
            }
          }
          
          this.categoryDetails = this.mGetAllShopAllModuleDataResponse.data.categoryDetails[0]
          if (this.mGetAllShopAllModuleDataResponse && this.mGetAllShopAllModuleDataResponse.data) {
              this.getAllProductByParameters();
              this.getPriceLists()
          }
        } else {
        }
      })
    }
    else{
      const getAllModuleDataOfShopAll = this.wsShopAllService.getAllModuleDataOfShopAllWithoutCategory()
      await lastValueFrom(getAllModuleDataOfShopAll).then(async response => {
        if (response && response.statusCode == 200) {
          this.mGetAllShopAllModuleDataResponse.data = response.data;
          this.categoryDetails = this.mGetAllShopAllModuleDataResponse.data.categoryDetails[0]
          if (this.mGetAllShopAllModuleDataResponse && this.mGetAllShopAllModuleDataResponse.data) {
            this.getAllProductByParameters();
            this.getPriceLists()
          }
        } else {
        }
      })
    }
    }
  }

  /**
   * Date: 10-06-23
   * Method : This method is used to get all brand 
   */
  async getAllBrand() {
    this.mCommonListModalRequest.take = 100;
    this.mCommonListModalRequest.isAllowInactive = false;
    if(this.mCommonListModalRequest.skip == 0){
      this.mGetBrandResponse.data = []
    }
    if(this.categoryId){
      this.mCommonListModalRequest.categoryIds = ""+this.categoryId;
    }
    const getAllBrand = this.wsShopAllService.getAllBrand(this.mCommonListModalRequest)
    await lastValueFrom(getAllBrand).then(async response => {
      if (response && response.statusCode == 200) {
        if (this.mGetBrandResponse.data.length < 1) {
          this.mGetBrandResponse.data = response.data;
        } else {
          this.mGetBrandResponse.data = [...this.mGetBrandResponse.data, ...response.data];
        }
        this.brandCount = this.mGetBrandResponse.data.length
      } else {
      }
    })
  }

  /**
   * Date: 10-06-23
   * Method : This method is used to get all cart items 
   */
  async getAllCartProducts() {
    const getAllCart = this.wsShopAllService.getCartList("" + SharedPrefrences.getUserId())
    await lastValueFrom(getAllCart).then(async response => {
      if (response && response.statusCode == 200) {
        this.mAddUpdateCartModuleResponse.data = response.data;
      } else {
      }
    })
  }

  async getGender() {
    const getGender = this.wsShopAllService.getGender()
    await lastValueFrom(getGender).then(async response => {
      if (response && response.statusCode == 200) {
        this.genderList = response.data;
      } else {
      }
    })
  }


  async getAllSubCategory() {
    this.mCommonListModalRequest.take = 100;
    if(this.mCommonListModalRequest.skip == 0){
      this.subCategoryList = []
    }
    if(this.categoryId){
      this.mCommonListModalRequest.categoryIds = ""+this.categoryId;
    }
    const getAllSubCategory = this.wsShopAllService.getAllSubCategory(this.mCommonListModalRequest)
    await lastValueFrom(getAllSubCategory).then(async response => {
      if (response && response.statusCode == 200) {
        if (this.subCategoryList.length < 1) {
          this.subCategoryList = response.data;
        } else {
          this.subCategoryList = [...this.subCategoryList, ...response.data];
        }
        this.subCategoryCount = this.subCategoryList.length
      } else {
      }
    })
  }

  /**
   * Date: 10-06-23
   * Method : This method is used to get brand by its name and initials
   */
  async getAllBrandByInitials() {
    this.mGetBrandResponse.data = [];
    const getAllBrand = this.wsShopAllService.getBrandByInitials(this.mGetBrandByInitialsRequest)
    await lastValueFrom(getAllBrand).then(async response => {
      if (response && response.statusCode == 200) {
        this.mGetBrandResponse.data = response.data;
      } else {
      }
    })
  }

  /**
   * Date: 10-06-23
   * Method: This method is used to get all product by parameter passed
   */
  async getAllProductByParameters() {
    this.isLoading = true;
    if(this.discountType){
      this.mGetProductRequest.discountType = this.discountType
      this.mGetProductRequest.isdiscounted = this.isdiscounted
    }
    if(this.discountmode){
      this.mGetProductRequest.discountmode = this.discountmode
      this.mGetProductRequest.isdiscounted = this.isdiscounted
    }
    if(this.discountValueType){
      this.mGetProductRequest.discountValueType = this.discountValueType
      this.mGetProductRequest.isdiscounted = this.isdiscounted
    }
    if(this.discountValue){
      this.mGetProductRequest.discountValue = this.discountValue
      this.mGetProductRequest.isdiscounted = this.isdiscounted
    }

    if (this.categoryId && this.categoryId != '') {
      this.mGetProductRequest.categoryIds = ""+this.categoryId
    }
    if (this.subCategoryId && this.subCategoryId != '') {
      this.mGetProductRequest.sub_category_id = "" + this.subCategoryId;
    }
    if (this.leafLevelCategoryId && this.leafLevelCategoryId != '') {
      this.mGetProductRequest.leaf_level_category_Ids = "" + this.leafLevelCategoryId;
    }
    if (this.skinConcernId && this.skinConcernId != '') {
      this.mGetProductRequest.skin_concerns = "" + this.skinConcernId;
    }
    if (this.skinTypeId && this.skinTypeId != '') {
      this.mGetProductRequest.skin_type = "" + this.skinTypeId;
    }
    if (this.brandId && this.brandId != '') {
      this.mGetProductRequest.brand = "" + this.brandId;
    }
    if (this.relevence) {
      this.mGetProductRequest.relevence = this.relevence;
    }
    if (this.tags) {
      this.mGetProductRequest.tags = this.tags;
    }
    if (this.priceHighToLow != null) {
      this.mGetProductRequest.priceHighToLow = this.priceHighToLow;
    }
    if (this.pricerange != null) {
      this.mGetProductRequest.pricerange = this.pricerange;
    }

    if (this.gender != null) {
      this.mGetProductRequest.gender = this.gender;
    }
    const getAllProductByParameters = this.wsShopAllService.getAllProductByParameters(this.mGetProductRequest)
    await lastValueFrom(getAllProductByParameters).then(async response => {
      this.mGetProductResponse.totalRecords = response.totalRecords;
      this.mGetProductResponse.data = []
      this.previousPage = this.selectedPage
      this.totalPages = Math.ceil(this.mGetProductResponse.totalRecords/this.mGetProductRequest.take)
      if(this.totalPages > 0 && this.selectedPage == 1){
        this.pageList = [];
        for (var i = 1; i <= 4; i++) {
          if(this.totalPages >= i){
            this.pageList.push(i);
          }
        }
      }
      if (this.mGetProductResponse.data && this.mGetProductResponse.data.length < 1) {
        this.mGetProductResponse.data = response.data;
        if (this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0) {
          this.mGetProductResponse.data.forEach((product: any) => {
            const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (cartPresent.length > 0) {
              product.cartQty = cartPresent[0].qty;
            }
          })
        }
        if (this.mWishlistData && this.mWishlistData.length > 0) {
          this.mGetProductResponse.data.forEach((product: any) => {
            const present = this.mWishlistData.some(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (present) {
              product.like = true;
            }
          })
        }
      } else {
        if (this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0) {
          response.data.forEach((product: any) => {
            const cartPresent = this.mAddUpdateCartModuleResponse.data.findIndex(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (cartPresent > -1) {
              product.cartQty = cartPresent.qty;
            }
          })
        }
        if (this.mWishlistData && this.mWishlistData.length > 0) {
          response.data.forEach((product: any) => {
            const present = this.mWishlistData.some(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (present) {
              product.like = true;
            }
          })
        }
        this.mGetProductResponse.data = [...this.mGetProductResponse.data, ...response.data];
      }
      this.isLoading = false;
      this.productCount = this.mGetProductResponse.data.length;
      window.scrollTo(0, 0);
    }, (error)=>{
      this.isLoading = false;
    })
  }


  async getPriceLists() {
    this.priceLists = [];
    if (this.categoryId && this.categoryId != '') {
      this.mGetPriceListRequest.category_id = ""+this.categoryId
    }
    if (this.subCategoryId && this.subCategoryId != '') {
      this.mGetPriceListRequest.sub_category_id = "" + this.subCategoryId;
    } 
    if (this.leafLevelCategoryId && this.leafLevelCategoryId != '') {
      this.mGetPriceListRequest.leaf_level_category_Ids = "" + this.leafLevelCategoryId;
    } 
    if (this.skinConcernId && this.skinConcernId != '') {
      this.mGetPriceListRequest.skin_concerns = "" + this.skinConcernId;
    } 
    if (this.skinTypeId && this.skinTypeId != '') {
      this.mGetPriceListRequest.skin_type = "" + this.skinTypeId;
    } 
    if (this.brandId && this.brandId != '') {
      this.mGetPriceListRequest.brand = "" + this.brandId;
    } 
    if (this.relevence) {
      this.mGetPriceListRequest.relevence = this.relevence;
    }
    if (this.priceHighToLow != null) {
      this.mGetPriceListRequest.priceHighToLow = this.priceHighToLow;
    }
    if (this.gender != null) {
      this.mGetPriceListRequest.gender = this.gender;
    }

    const getAllPriceList = this.wsShopAllService.getPriceList(this.mGetPriceListRequest)
    await lastValueFrom(getAllPriceList).then(async response => {
      if (response && response.statusCode == 200) {
        this.priceLists = response.data;
      }
    })
  }

  /**
   * Date: 10-06-23
   * Method : This method is used to search brand by name
   * @param e : This param is input event of search for brand
   */
  searchBrand(e: any) {
    if (e.target.value == '') {
      this.mGetBrandResponse.data = []
      this.getAllBrand();
    } 
    else {
      if (e.target.value.length > 0) {
        this.mGetBrandByInitialsRequest.name = e.target.value;
        this.getAllBrandByInitials()
      }
    }
  }

  selectSubCategory(val: any, web?: boolean) {
    if(val == ''){
      this.selectedSubCategory = []
    }else{
      var index = this.selectedSubCategory.findIndex((subCategory: any) => subCategory == val)
      if (index > -1) {
        this.selectedSubCategory.splice(index, 1)
      } else {
        this.selectedSubCategory.push(''+val)
      }
   }

    this.subCategoryId = this.selectedSubCategory.join(',')
    if(this.selectedSubCategory && this.selectedSubCategory.length > 0){
      this.leafLevelCategoryList = []
      this.wsShopAllService.getLeafCategoryList(this.subCategoryId).subscribe((res:any) =>{
        this.leafLevelCategoryList = res['data']
      })
    }else{
      this.wsShopAllService.getLeafCategoryList().subscribe((res:any) =>{
        this.leafLevelCategoryList = res['data']
      })
    }
    if (web) {
      this.selectedPage = 1;
      this.appyFilter()
    }
  }

  selectLeafLevelCategory(val: any, web?: boolean) {
    if(val == ''){
      this.selectedLeafLevelCategory = []
    }else{
      var index = this.selectedLeafLevelCategory.findIndex((leafLevelCategory: any) => leafLevelCategory == val)
      if (index > -1) {
        this.selectedLeafLevelCategory.splice(index, 1)
      } else {
        this.selectedLeafLevelCategory.push(''+val)
      }
   }

    this.leafLevelCategoryId = this.selectedLeafLevelCategory.join(',')
    if (web) {
      this.selectedPage = 1;
      this.appyFilter()
    }
  }


  selectPrice(val: any, web?: boolean) {
    if(val == ''){
      this.selectedPrice = []
    }else{
      var indexes = this.selectedPrice.filter((i:any)=>i == val)
      if(indexes.length > 0){
        for(var i=0;i<this.selectedPrice.length;i++){
          for(var j=0;j<indexes.length;j++){
            let strIndex = ""+(i+1)
            if(indexes[j] == this.selectedPrice[i]){
              this.selectedPrice.splice(i, 1)
              break;
            }
          }
        }   
      }else{
        this.selectedPrice.push(val)
      }
   }
    this.pricerange = this.selectedPrice.join(',')
    if (web) {
      this.selectedPage = 1;
      this.appyFilter()
    }
  }
  
  selectGender(val: any, web?: boolean) {
    if(parseInt(this.gender, 10) == val){
      this.gender = null
    }else{
      this.gender = val;
    }
    if (web) {
      this.selectedPage = 1;
      this.appyFilter()
    }
  }

  
  selectCategory(val: any, web?: boolean) {
    var index = this.selectedCategory.findIndex((category: any) => category == val)
    if (index > -1) {
      this.selectedCategory.splice(index, 1)
    } else {
      this.selectedCategory.push(''+val)
    }

    this.categoryId = this.selectedCategory.join(',')
    this.getAllBrand();
    this.getAllModuleDataOfShopAll()
    if (web) {
      this.selectedPage = 1;
      this.appyFilter()
    }
  }
  /**
   * Date: 10-06-23
   * Method: This method is used ot filter products by skin concern
   * @param val : This param is a ids of skin concern
   */
  selectSkinConcern(val: any, web?: boolean) {
    var index = this.skinConcernArray.findIndex((skinConcern: any) => skinConcern == val)
    if (index > -1) {
      this.skinConcernArray.splice(index, 1)
    } else {
      this.skinConcernArray.push(''+val)
    }
    this.skinConcernId = this.skinConcernArray.join(',');
    if (web) {
      this.selectedPage = 1;
      this.appyFilter()
    }
  }

  /**
   * Date: 10-06-23
   * Method: This method is used ot filter products by skin type
   * @param val : This param is a ids of skin type
   */
  selectSkinType(val: any, web?: boolean) {
    var index = this.skinTypeArray.findIndex((skinType: any) => skinType == val)
    if (index > -1) {
      this.skinTypeArray.splice(index, 1)
    } else {
      this.skinTypeArray.push(''+val)
    }
    this.skinTypeId = this.skinTypeArray.join(',');
    if (web) {
      this.selectedPage = 1;
      this.appyFilter()
    }
  }

  /**
   * Date: 10-06-23
   * Method: This method is used ot filter products by brand
   * @param val : This param is a id of Brand
   */
  selectBrand(val: any, web?: boolean) {
    var index = this.selectedBrandList.findIndex((brand: any) => brand == val)
    if (index > -1) {
      this.selectedBrandList.splice(index, 1)
      if(this.selectIndex>0){
        this.selectIndex -= 1;
      }
    } else {
      this.selectedBrandList.push(''+val)
      this.selectIndex += 1;
    }

    this.brandId = this.selectedBrandList.join(',')
    if (web) {
      this.selectedPage = 1;
      this.appyFilter()
    }
  }

  appyFilter() {
    this.mGetProductRequest = new MGetProductRequest()
    this.mGetProductRequest.skip = 0
    this.updateURLWithNewParamsWithoutReloading()
    this.getAllProductByParameters();
    this.getPriceLists()
  }

  filterCommon(val:any){
    var array = [];
    if(val == ''){
      array = []
    }else{
      array = val.split(',');
   }
   return array;
  }

  clearFilter() {
    this.selectedBrandList = []
    this.brandId = ''
    this.skinTypeArray = [];
    this.skinTypeId = '';
    this.skinConcernArray = [];
    this.skinConcernId = '';
    this.selectedCategory = [1];
    this.categoryId = '1';
    this.selectedSubCategory = [];
    this.selectedLeafLevelCategory = [];
    this.subCategoryId = '';
    this.leafLevelCategoryId = '';
    this.mGetProductRequest = new MGetProductRequest()
    this.mGetProductRequest.skip = 0
    this.updateURLWithNewParamsWithoutReloading(true)
    this.getAllProductByParameters();
    this.getPriceLists()
  }


  /**
   * Date: 10-06-23
   * Method: This method is used to open and close the sortby toggle
   */
  setSortBy() {
    this.sortBy = !this.sortBy
  }

  setSortByOne() {
    this.sortByOne = !this.sortByOne
  }

  /**
   * Date: 10-06-23
   * Method : This method is used to filter product by relevance
   */
  selectRelevance(web?:any) {
    if(!this.relevence){
      this.relevence = true;
      this.priceHighToLow = null;
    }else{
      this.relevence = null;
    }
    if(this.relevence && this.priceHighToLow == true){
      this.selectedSortBy = '(Popularity,Price High to low)'
    }else
    if(this.relevence && this.priceHighToLow == false){
      this.selectedSortBy = '(Popularity,Price Low to High)'
    }else if(!this.relevence && this.priceHighToLow == true){
      this.selectedSortBy = '(Price High to low)'
    }
    else if(!this.relevence && this.priceHighToLow == false){
      this.selectedSortBy = '(Price Low to High)'
    }else{
      this.selectedSortBy = '(Popularity)'
    }
    if(!this.relevence && this.priceHighToLow==null){
      this.selectedSortBy = '';
    }
    this.mGetProductRequest = new MGetProductRequest()
    this.mGetProductRequest.skip = 0
    if(web){
      this.selectedPage = 1;
      this.updateURLWithNewParamsWithoutReloading()
      this.getAllProductByParameters()
      this.getPriceLists()
    }
  }

  selectLowToHigh(val:any , web?:any){
    if(this.priceHighToLow == val){
      this.priceHighToLow = null;
    }else{
      this.priceHighToLow = val;
      this.relevence = null;
    }
    this.selectPriceSort(web)
  }

  selectHighToLow(val:any , web?:any){
    if(this.priceHighToLow == val){
      this.priceHighToLow = null;
    }else{
      this.priceHighToLow = val;
      this.relevence = null;
    }
    this.selectPriceSort(web)
  }


  /**
   * Date: 10-06-23
   * Method : This method is used to filter product by price high to low and low to high
   * @param val : This param is the value true/false 
   */
  selectPriceSort(web?:any) {
    this.mGetProductRequest = new MGetProductRequest()
    this.mGetProductRequest.skip = 0
    if(this.relevence && this.priceHighToLow == true){
      this.selectedSortBy = '(Popularity,Price High to low)'
    }else
    if(this.relevence && this.priceHighToLow == false){
      this.selectedSortBy = '(Popularity,Price Low to High)'
    }else if(!this.relevence && this.priceHighToLow == true){
      this.selectedSortBy = '(Price High to low)'
    }else
    if(!this.relevence && this.priceHighToLow == false){
      this.selectedSortBy = '(Price Low to High)'
    }else{
      this.selectedSortBy = '(Popularity)'
    }
    if(!this.relevence && this.priceHighToLow==null){
      this.selectedSortBy = ''
    }
    if(web){
      this.selectedPage = 1;
      this.updateURLWithNewParamsWithoutReloading()
      this.getAllProductByParameters()
      this.getPriceLists()
    }
  }

  onScroll() {
    if (this.brandCount < this.mCommonListModalRequest.skip) {
      this.mCommonListModalRequest.skip = this.brandCount;
      this.getAllBrand();
    }
  }

  onScrollProduct() {
    if (this.productCount < this.mGetProductResponse.totalRecords) {
      this.mGetProductRequest.skip = this.productCount;
      this.getAllProductByParameters();
    }
  }

  showProduct(product: any) {
    var productName = product.name.split(' ').join('_').replace(',', '')
    this.router.navigate(["/product-detail-updated/" + product.id + '/' + productName.replace(/[&\/\#,+()$~%.'":*?<>{}]/g,'_')])
  }

  buyNowCommon(product: any) {
    const productDetail = {
      qty: 1,
      productId: product.id
    }
    localStorage.setItem("buynow", JSON.stringify(productDetail))
    const userAgent = window.navigator.userAgent.toLowerCase();
    var mobile = /iphone|ipad|ipod|android|blackberry|iemobile|opera mini/i.test(userAgent)
    if(mobile){
      this.router.navigate(["/checkout-new-mob/buynow/" + product.id])
    }else{
      this.router.navigate(["/checkout-new/buynow/" + product.id])
    }
  }

  buyNow(product: any) {
    if (SharedPrefrences.getUserId() != null && SharedPrefrences.getUserId() != '') {
      this.buyNowCommon(product)
    } else {
      const modalRef = this.modalService.open(LoginPopupComponent);
      modalRef.componentInstance.type = 1;
      modalRef.componentInstance.emitService.subscribe((emmitedValue: any) => {
        if (emmitedValue) {
          this.buyNowCommon(product)
        }
      })
    }
  }

  async addToCartCommon(product: any, index?: any) {
    this.mAddUpdateCartModule.user_id = "" + SharedPrefrences.getUserId();
    this.mAddUpdateCartModule.product_id = product.id;
    if (this.type == 'cart') {
      this.mAddUpdateCartModule.iswishlistitem = false;
    } else {
      this.mAddUpdateCartModule.iswishlistitem = true;
    }
    if (this.type == "cart") {
      const cart = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.findIndex((cart: any) => { return cart.product_id === product.id })
      if (cart > -1) {
        this.mAddUpdateCartModule.qty = this.mAddUpdateCartModuleResponse.data[cart].qty + 1;
        this.mAddUpdateCartModule.id = this.mAddUpdateCartModuleResponse.data[cart].id;
      } else {
        this.mAddUpdateCartModule.qty = 1;
      }
      const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
      await lastValueFrom(addRemoveProductFromCart).then(async response => {
        if (response && response.statusCode == 200) {
          this.mGetProductResponse.data[index]['cartQty'] = this.mAddUpdateCartModule.qty;
          this.mAddUpdateCartModule = new MAddUpdateCartModule();
          this._commonBehaviorChangeService.addCart(true);
        } else {
          console.log("something went wrong")
        }
      })
    } else {
      this.mAddUpdateCartModule.iswishlistitem = product.like ? false : true;
      if (product.like) {
        const wishlist = this.mWishlistData && this.mWishlistData.findIndex((wishlist: any) => { return wishlist.product_id === product.id })
        if (wishlist > -1) {
          this.mAddUpdateCartModule.id = this.mWishlistData[wishlist].id;
        }
      }
      this.mAddUpdateCartModule.qty = product.like ? 0 : 1;
      const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
      await lastValueFrom(addRemoveProductFromCart).then(async response => {
        if (response && response.statusCode == 200) {
          this.mGetProductResponse.data[index].like = product.like ? false : true;
          this._commonBehaviorChangeService.addWishlist(true)
        } else {
          console.log("something went wrong")
        }
      })
    }
  }

  async addtoCart(product: any, val: any, index?: any) {
    this.type = val;
    if (SharedPrefrences.getUserId() != null && SharedPrefrences.getUserId() != '') {
      this.addToCartCommon(product, index)
    } else {
      const modalRef = this.modalService.open(LoginPopupComponent);
      modalRef.componentInstance.type = 1;
      modalRef.componentInstance.emitService.subscribe((emmitedValue: any) => {
        if (emmitedValue) {
          this.addToCartCommon(product, index)
        }
      })
    }
  }

  presentWishlist(id: any) {
    var isPresent = this.mWishlistData.some(function (el: any) { return el.productdetail.id === id && el.qty > 0 });
    return isPresent;
  }

  async addCartItem(product: any, index: any) {
    this.mAddUpdateCartModule.user_id = "" + SharedPrefrences.getUserId();
    this.mAddUpdateCartModule.product_id = product.id;
    this.mGetProductResponse.data[index]['cartQty'] = this.mGetProductResponse.data[index]['cartQty'] + 1
    this.mAddUpdateCartModule.qty = this.mGetProductResponse.data[index]['cartQty']
    this.mAddUpdateCartModule.iswishlistitem = false;
    const cart = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.findIndex((cart: any) => { return cart.product_id === product.id })
    if (cart > -1) {
      this.mAddUpdateCartModule.id = this.mAddUpdateCartModuleResponse.data[cart].id;
    }
    const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
    await lastValueFrom(addRemoveProductFromCart).then(async response => {
      if (response && response.statusCode == 200) {
        this.mAddUpdateCartModule = new MAddUpdateCartModule();
        this._commonBehaviorChangeService.addCart(true);
      } else {
        console.log("something went wrong")
      }
    })
  }

  async removeCartItem(product: any, index: any) {
    this.mAddUpdateCartModule.user_id = "" + SharedPrefrences.getUserId();
    this.mAddUpdateCartModule.product_id = product.id;
    this.mAddUpdateCartModule.iswishlistitem = false;
    const cart = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.findIndex((cart: any) => { return cart.product_id === product.id })
    if (cart > -1) {
      this.mAddUpdateCartModule.id = this.mAddUpdateCartModuleResponse.data[cart].id;
    }
    if (product.cartQty > 0) {
      this.mGetProductResponse.data[index]['cartQty'] = this.mGetProductResponse.data[index]['cartQty'] - 1
      this.mAddUpdateCartModule.qty = this.mGetProductResponse.data[index]['cartQty']
    } else {
      this.mAddUpdateCartModule.qty = 0;
      delete this.mGetProductResponse.data[index]['cartQty']
    }
    const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
    await lastValueFrom(addRemoveProductFromCart).then(async response => {
      if (response && response.statusCode == 200) {
        this.mAddUpdateCartModule = new MAddUpdateCartModule();
        this._commonBehaviorChangeService.addCart(true);
      } else {
        console.log("something went wrong")
      }
    })
  }

  handleImageError(img:any) {
    img.target.src = "assets/images/no-image-png.png";
    img.onerror = null; // Remove onerror to prevent infinite loop
}

  selectPage(page:any){
    this.selectedPage = page;
    this.mGetProductRequest.skip = (this.selectedPage - 1) * this.mGetProductRequest.take;
    this.pageList = [];
    if(this.totalPages > 4){
      if(this.totalPages - this.selectedPage > 3){
      for (var i = this.selectedPage; i <= 2 + this.selectedPage; i++) {
        if(this.totalPages >= i){
            this.pageList.push(i);
          }
        }
      }
      
      var newPage = 0;
      if(this.totalPages - this.selectedPage == 3){
        newPage = this.selectedPage;
        for (var j = newPage; j <= this.totalPages; j++) {
          if(this.totalPages >= j){
            this.pageList.push(j);
          }
        }
      }
      if(this.totalPages - this.selectedPage == 2){
        newPage =  this.selectedPage - 1
        for (var j = newPage; j <= this.totalPages; j++) {
          if(this.totalPages >= j){
            this.pageList.push(j);
          }
        }
      }

      if(this.totalPages - this.selectedPage == 1){
        newPage =  this.selectedPage - 2
        for (var j = newPage; j <= this.totalPages; j++) {
          if(this.totalPages >= j){
            this.pageList.push(j);
          }
        }
      }

      
      if(this.totalPages - this.selectedPage == 0){
        newPage =  this.selectedPage - 3
        for (var j = newPage; j <= this.totalPages; j++) {
          if(this.totalPages >= j){
            this.pageList.push(j);
          }
        }
      }
    }else{
      for (var j = 1; j <= this.totalPages; j++) {
        if(this.totalPages >= j){
          this.pageList.push(j);
        }
      }
  }

    this.getAllProductByParameters();
    this.getPriceLists();
  }
    
}
